import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SingleCheckboxComponent } from './single-checkbox.component';

@NgModule({
  declarations: [SingleCheckboxComponent],
  imports: [CommonModule, ReactiveFormsModule],
  exports: [SingleCheckboxComponent],
})
export class SingleCheckboxModule {}
